import React from 'react'

import { Text, FontFamily, FontWeight, Color } from '@gousto-internal/citrus-react'
import { Recipe } from '@library/menu-service'

export const CaloriesText = ({ recipe }: { recipe: Recipe }) => {
  const caloriesToDisplay = recipe.nutritionalInformation.perPortion.energyKcal

  if (!caloriesToDisplay) {
    return null
  }

  return (
    <Text
      size={2}
      fontFamily={FontFamily.Book}
      fontWeight={FontWeight.Normal}
      color={Color.ColdGrey_600}
    >
      •&nbsp;&nbsp;{`${caloriesToDisplay} kcal`}
    </Text>
  )
}
